import {ToastOptions} from "react-toastify";

export const TOAST_CONFIG: ToastOptions = {
  position: "bottom-right",
  autoClose: 2000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: false,
  draggable: false,
  theme: "dark",
};
